import React from 'react';
import { motion } from 'framer-motion';
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-[#D89B16]/30" data-id="element-39" data-mp="uoh613eipwbq">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-40" data-mp="uqljod27y9p7">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#081632] mb-6" data-id="element-41" data-mp="1icibu4kbayng">
          What Judo coaches are really looking for is not more information.
        </h2>
        <p className="text-xl text-[#081632]/75 mb-8" data-id="element-42" data-mp="18n8ikldqf9xr">
          <span className="text-[#D89B16] font-semibold" data-id="element-43" data-mp="18lxhwufl2iav">It is more structure. More clarity.</span>{' '}
          A better way to turn what they already know into sessions that feel organized,
          progressive and professional.
        </p>
        <div className="bg-white border border-[#D89B16]/40 rounded-2xl p-8 shadow-sm shadow-[#1E4ED8]/10 text-lg text-slate-700 space-y-2" data-id="element-44" data-mp="1wdb6cpam5tqk">
          <p data-id="element-45" data-mp="24wednu6lzjyz">
            With Judo Coach Ready, you do not have to begin every session from an empty page.
          </p>
          <p className="text-[#081632] font-semibold" data-id="element-46" data-mp="28z13jpjpyutj">You already have the framework.</p>
          <p className="text-[#081632] font-semibold" data-id="element-47" data-mp="1v3p3r3qpie5r">You already have the progression.</p>
          <p className="text-[#081632] font-semibold" data-id="element-48" data-mp="202s07zsmfc24">You already have the visual coaching tools.</p>
          <p className="text-[#081632] font-semibold" data-id="element-49" data-mp="1l9q72k9ejml7">
            And with 150 ready-to-coach sessions, you already have the session.
          </p>
        </div>
      </motion.div>
    </section>;
}